import React, { useCallback, useMemo } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { Grid } from '@material-ui/core'
import dayjs from 'dayjs'
import Loading from '../../../molecules/Loading'
import EmptySection from '../../../atoms/EmptySection'
import OperationalTable from '../../../organisms/OperationalTable'
import { useListUnmanagedSchedules } from '../../../../api/scheduler'

function extractResourceName (arn) {
  if (!arn) return '\u2014'
  const parts = arn.split(':')
  return parts[parts.length - 1] || arn
}

const columns = [
  { id: 'name', accessor: 'name', Header: 'Name' },
  {
    id: 'state',
    accessor: 'state',
    Header: 'State',
    // eslint-disable-next-line react/prop-types
    Cell: ({ value }) => value === 'ENABLED' ? 'Enabled' : 'Disabled'
  },
  {
    id: 'target',
    accessor: 'targetArn',
    Header: 'Target',
    // eslint-disable-next-line react/prop-types
    Cell: ({ value }) => (
      <span title={value}>{extractResourceName(value)}</span>
    )
  },
  {
    id: 'createdAt',
    accessor: 'createdAt',
    Header: 'Created',
    // eslint-disable-next-line react/prop-types
    Cell: ({ value }) => value ? dayjs(value).format('MMM D, YYYY h:mm A') : '\u2014'
  },
  {
    id: 'lastModifiedAt',
    accessor: 'lastModifiedAt',
    Header: 'Last Modified',
    // eslint-disable-next-line react/prop-types
    Cell: ({ value }) => value ? dayjs(value).format('MMM D, YYYY h:mm A') : '\u2014'
  }
]

function UnmanagedSchedules () {
  const { data: schedules, isLoading } = useListUnmanagedSchedules()
  const history = useHistory()
  const { url } = useRouteMatch()

  const tableData = useMemo(() => schedules || [], [schedules])

  const handleRowClick = useCallback((row) => {
    history.push(`${url}/${row.original.name}`)
  }, [history, url])

  if (isLoading) {
    return <Loading />
  }

  if (!tableData.length) {
    return (
      <EmptySection
        title='No Unmanaged Schedules'
        description='All schedules in this firm are managed, or no EventBridge schedules exist yet.'
      />
    )
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <OperationalTable
          variant='v2'
          columns={columns}
          data={tableData}
          defaultSort={[{ id: 'name', desc: false }]}
          onRowClick={handleRowClick}
        />
      </Grid>
    </Grid>
  )
}

export default UnmanagedSchedules
